import React from "react";

import l10n from "../../l10n/localization";
import Tabs from "react-toolbox/lib/tabs/Tabs";
import Tab from "react-toolbox/lib/tabs/Tab";
import CargoForm from "../forms/CargoForm";
import LoadingPort from "./LoadingPort";
import * as utils from "../../utils/utils";
import OutturnInformationForm from "../forms/OutturnInformationForm";
import {connect} from "react-redux";
import {flattenCommodity} from "../../utils/cargo";

class CargoTabs extends React.Component {

    state = {
        activeTab: 0,
    };


    handleTabChange = (activeTab) => {
        this.setState({activeTab});
    };

    render() {
        let cargo = null;
        let isNew = false;

        if ((!utils.notNullNorUndefined(this.props.item) || !utils.notNullNorUndefined(this.props.item.item) || !utils.notNullNorUndefined(this.props.item.item.id)) && this.props.newlyCreatedElement === null) {
            isNew = true;
        } else {
            cargo = {...this.props.item.item};
            if (this.props.newlyCreatedElement !== null) {
                cargo = flattenCommodity(this.props.cargoes.getById(this.props.newlyCreatedElement));
                if (!utils.notNullNorUndefined(cargo)) {
                    isNew = true;
                }
            } else {
                if (utils.notNullNorUndefined(this.props.item) && utils.notNullNorUndefined(this.props.item.item)) {
                    cargo = flattenCommodity(this.props.cargoes.getById(this.props.item.item.id));
                }
            }
        }

        /*let currentCargo = this.props.item.item;
        if (this.props.newlyCreatedElement !== null) {
            currentCargo = this.props.cargoes.getById(this.props.newlyCreatedElement);
        } else {
            console.log("JMA", this.props.newlyCreatedElement, this.props, currentCargo);
            currentCargo = this.props.cargoes.getById(this.props.item.item.id);
        }*/

        return (
            <section className="cargo-tabs">
                {!isNew && <h1>Cargo{utils.notNullNorUndefined(cargo) && utils.notNullNorUndefined(cargo.commodityName)  && " - " + cargo.commodityName}</h1>}
                {isNew && <h1>New Cargo</h1>}
                <Tabs index={this.state.activeTab} onChange={this.handleTabChange}>
                    <Tab label={l10n.common.general}>
                        <CargoForm openDrawer={this.props.openDrawer} item={{...this.props.item, item: cargo}} fog={this.props.fog} depth={this.props.depth} />
                    </Tab>
                    <Tab label={l10n.port.ports} disabled={isNew}>
                        {!isNew && <LoadingPort item={{...this.props.item, item: cargo}} cargo={cargo} openDrawer={this.props.openDrawer} />}
                    </Tab>
                    <Tab label={l10n.cargo.outturnInformation} disabled={isNew}>
                        {!isNew && <OutturnInformationForm openDrawer={this.props.openDrawer} item={{...this.props.item, item: cargo}} fog={this.props.fog} depth={this.props.depth} />}
                    </Tab>
                </Tabs>
            </section>
        )
    }
};

export default connect((state) => {
    return Object.assign({}, {
        newlyCreatedElement: state.creation.newlyCreatedCargo,
        cargoes: state.cargo.cargoes,
    });
})(CargoTabs);


// WEBPACK FOOTER //
// ./src/components/cargo/CargoTabs.js